export default __webpack_public_path__ + "static/media/creativity.8b0cafc8.png";